import React from 'react';
import { CordexaLoader } from './CordexaLoader';
import styles from './ContentRegionLoader.module.css';

export type ContentRegionLoaderProps = {
  label: string;
  subtitle?: string;
  minHeight?: string;
  className?: string;
  'data-testid'?: string;
};

export function ContentRegionLoader({
  label,
  subtitle,
  minHeight = '240px',
  className,
  'data-testid': dataTestId = 'content-region-loader',
}: ContentRegionLoaderProps) {
  const srLabel = subtitle ? `${label}. ${subtitle}` : label;

  return (
    <div
      className={[styles.root, className].filter(Boolean).join(' ')}
      style={{ minHeight }}
      data-testid={dataTestId}
      role="status"
      aria-busy="true"
      aria-live="polite"
    >
      <CordexaLoader
        variant="dots"
        size="md"
        srLabel={srLabel}
        data-testid="cordexa-loader-present"
      />
    </div>
  );
}
